<template>
  <h2>چاپ عکس رنگی</h2>

  <ul class="list-group">
    <li
      class="list-group-item d-flex justify-content-between align-items-center"
      v-for="(img, index) in imgSize"
      :key="index"
    >
      {{ img.w }}×{{ img.h }}
      <span class="badge bg-primary rounded-pill">0 تومان</span>
    </li>
  </ul>

  <div class="input-group my-3">
    <label class="input-group-text" for="inputGroupFile01">Upload</label>
    <input type="file" class="form-control" @change="onFileSelected" />
  </div>
  <button class="btn btn-danger mb-3" @click="onUpload">ثبت تصویر</button>

 
    <div v-if="imageData" class="">
      <div class="row g-4">
        <div class="col-md-5">
          <img :src="imageData" class="rounded w-100" alt="" />
        </div>
        <div class="col-md-7">
          <div class="list-group">
            <a href="#" class="list-group-item list-group-item-action">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">ابعاد تصویر</h5>
                <small>{{ test.w }}×{{ test.h }} نقطه</small>
              </div>
              <p class="mb-1">
                تصویر انتخابی شما
                <strong>{{ objProperties.mp }} مگاپیکسل</strong> میباشد
              </p>
              <small
                >با افزایش ابعاد تصویر در برنامه های ویرایش تصویر، کیفیت عکس
                بالا نمی رود، بلکه فقط حجم فایل زیاد میشود.</small
              >
            </a>
            <a href="#" class="list-group-item list-group-item-action">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">نسبت ابعاد تصویر</h5>
                <small class="text-muted">{{ nesbat }}</small>
              </div>
              <p class="mb-1">
                شما میتوانید از ابعاد موجود اندازه مورد نظر خود جهت چاپ عکس را
                انتخاب کنید.
              </p>
            </a>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
export default {
  name: "Upload",
  data() {
    return {
      imgSize: [
        { w: 10, h: 15 },
        { w: 13, h: 18 },
        { w: 16, h: 21 },
        { w: 20, h: 25 },
        { w: 20, h: 30 },
        { w: 30, h: 40 },
        { w: 9, h: 9 },
        { w: 13, h: 13 },
      ],
      imageData: null,
      objProperties: {},
      selectedFile: null,
      test: { w: 1, h: 3 },
    };
  },
  computed: {
    nesbat: function () {
      const r = gcd(this.test.w, this.test.h);
      return this.test.w / r + ":" + this.test.h / r;
    },
  },
  methods: {
    onFileSelected(e) {
      if (!e.target.files.length) return;
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        const src = e.target.result;

        const img = new Image();
        img.onload = () => {
          this.imageData = src;
          console.log(`${img.width} × ${img.height}`);
          console.log(`${Math.round((img.width * img.height) / 1000000, 2)}Mp`);
          console.log(((img.width * img.height) / 1000000).toFixed(1));

          this.objProperties.height = img.height;
          this.objProperties.width = img.width;
          this.objProperties.mp = ((img.width * img.height) / 1000000).toFixed(
            1
          );

          var w = img.width;
          var h = img.height;
          const r = gcd(w, h);
          this.objProperties.aspect = w / r + " : " + h / r;
          this.objProperties.r = r;

          this.test.w = w;
          this.test.h = h;
        };

        img.onerror = () => {
          console.log("error");
        };
        img.src = src;
      };
    },
    onupload() {},
  },
};

function gcd(a, b) {
  console.log(a, b);
  return b == 0 ? a : gcd(b, a % b);
}
</script>

<style>
</style>